import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Gift } from 'lucide-react';
export function BonosSection() {
  return <section className="py-16 px-4 bg-matrix-surface border-y border-matrix-dim relative overflow-hidden" data-id="element-5">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-6">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-7">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-matrix-orange/10 border border-matrix-orange/30 text-matrix-orange mb-4" data-id="element-8">
            <Gift className="w-4 h-4" data-id="element-9" />
            <span className="text-sm font-bold tracking-wide uppercase" data-id="element-10">
              Valor Total: $110
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-matrix-text mb-4" data-id="element-11">
            BONOS <span className="text-matrix-primary text-glow" data-id="element-12">GRATIS</span>
          </h2>
          <p className="text-xl text-matrix-muted max-w-2xl mx-auto" data-id="element-13">
            El "kit" que convierte el Protocolo Anti‑Matrix en algo que
            realmente haces.
          </p>
        </motion.div>

        {/* Emotional Intro */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-lg text-matrix-muted mb-16 space-y-6 text-center" data-id="element-14">
          <p data-id="element-15">
            Hay una razón por la que tanta gente "sabe" lo que tiene que hacer…
            y aun así termina en el mismo ciclo:
          </p>
          <p className="italic border-l-2 border-matrix-primary/30 pl-4 text-matrix-text/80" data-id="element-16">
            Empiezas bien. Te prometes "ahora sí". Y luego un día pesado, una
            emoción incómoda, una noche larga… y tu mano va al teléfono como si
            alguien más la moviera.
          </p>
          <p data-id="element-17">
            No es porque seas débil. Es porque estabas peleando contra un
            sistema…{' '}
            <span className="text-matrix-red font-bold" data-id="element-18">
              sin un sistema propio.
            </span>
          </p>
          <p className="text-matrix-primary font-medium" data-id="element-19">
            Por eso, hoy te llevas GRATIS (sí, gratis) un paquete de
            implementación que normalmente se vendería por separado.
          </p>
        </motion.div>

        {/* Bonus Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-20">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-matrix-bg border border-matrix-primary/20 rounded-xl overflow-hidden hover:border-matrix-primary/50 transition-colors group" data-id="element-21">
            <div className="aspect-video w-full bg-black/50 overflow-hidden relative" data-id="element-22">
              <div className="absolute inset-0 bg-gradient-to-t from-matrix-bg to-transparent z-10" data-id="element-23" />
              <img src="https://cdn.magicpatterns.com/uploads/tWATLzc47etq2YS2oBkeMH/workbook.png" alt="Workbook + Tracker" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-24" />
              <div className="absolute top-4 right-4 z-20 bg-matrix-bg/90 border border-matrix-primary/30 px-3 py-1 rounded text-xs font-mono text-matrix-primary" data-id="element-25">
                VALOR:{' '}
                <span className="line-through text-matrix-muted" data-id="element-26">$59</span>
              </div>
            </div>

            <div className="p-6 md:p-8" data-id="element-27">
              <h3 className="text-xl font-bold text-matrix-text mb-2" data-id="element-28">
                BONO #1 — Workbook + Tracker 30 Días
              </h3>
              <p className="text-matrix-muted text-sm mb-6" data-id="element-29">
                No es "otro workbook bonito". Es un tablero simple para tus
                próximos 30 días.
              </p>

              <ul className="space-y-3 mb-6" data-id="element-30">
                {['Contrato Anti‑Matrix (atención sagrada)', 'Tracker 30 días (mañana / pausa / cierre)', 'Lista de fricciones (eliges 2)', 'Reemplazos rápidos (eliges 3)', 'Checklist semanal (día 7/14/21/30)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-matrix-text/90" data-id="element-31">
                    <CheckCircle2 className="w-4 h-4 text-matrix-primary shrink-0 mt-0.5" data-id="element-32" />
                    <span data-id="element-33">{item}</span>
                  </li>)}
              </ul>

              <div className="p-3 bg-matrix-surface rounded border border-matrix-dim text-center text-sm text-matrix-primary font-medium" data-id="element-34">
                Resultado: dejas de improvisar y empiezas a ejecutar.
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-matrix-bg border border-matrix-primary/20 rounded-xl overflow-hidden hover:border-matrix-primary/50 transition-colors group" data-id="element-35">
            <div className="aspect-video w-full bg-black/50 overflow-hidden relative" data-id="element-36">
              <div className="absolute inset-0 bg-gradient-to-t from-matrix-bg to-transparent z-10" data-id="element-37" />
              <img src="https://cdn.magicpatterns.com/uploads/gFwfkgkMbQ5ozoQ7BAcT2r/libro_digital_version.png" alt="Libro Digital" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-38" />
              <div className="absolute top-4 right-4 z-20 bg-matrix-bg/90 border border-matrix-primary/30 px-3 py-1 rounded text-xs font-mono text-matrix-primary" data-id="element-39">
                VALOR:{' '}
                <span className="line-through text-matrix-muted" data-id="element-40">$51</span>
              </div>
            </div>

            <div className="p-6 md:p-8 flex flex-col h-full justify-between" data-id="element-41">
              <div data-id="element-42">
                <h3 className="text-xl font-bold text-matrix-text mb-2" data-id="element-43">
                  BONO #2 — Mente Maestra (Libro Digital)
                </h3>
                <p className="text-matrix-muted text-sm mb-6" data-id="element-44">
                  Tu libro digital para acompañar el audiolibro: releer,
                  subrayar, volver a lo clave en segundos y romper el trance
                  cuando el ruido te jala.
                </p>
              </div>

              <div className="mt-auto pt-6 border-t border-matrix-dim" data-id="element-45">
                <p className="text-center text-matrix-text/80 italic text-sm" data-id="element-46">
                  "La mejor forma de volver al camino es tener el mapa en el
                  bolsillo."
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Summary Stack */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-xl mx-auto bg-matrix-bg border border-matrix-primary/30 rounded-lg p-8 text-center shadow-[0_0_30px_rgba(0,255,65,0.1)]" data-id="element-47">
          <h3 className="text-lg font-bold text-matrix-text mb-6 uppercase tracking-widest" data-id="element-48">
            El Stack (Lo que recibes hoy)
          </h3>

          <div className="space-y-3 mb-8 text-left max-w-sm mx-auto" data-id="element-49">
            <div className="flex justify-between items-center text-matrix-muted" data-id="element-50">
              <span className="flex items-center gap-2" data-id="element-51">
                <CheckCircle2 className="w-4 h-4 text-matrix-primary" data-id="element-52" />{' '}
                Workbook + Tracker
              </span>
              <span className="line-through decoration-matrix-red" data-id="element-53">$59</span>
            </div>
            <div className="flex justify-between items-center text-matrix-muted" data-id="element-54">
              <span className="flex items-center gap-2" data-id="element-55">
                <CheckCircle2 className="w-4 h-4 text-matrix-primary" data-id="element-56" /> Libro
                Digital
              </span>
              <span className="line-through decoration-matrix-red" data-id="element-57">$51</span>
            </div>
            <div className="border-t border-matrix-dim my-2 pt-2 flex justify-between items-center font-bold text-matrix-text" data-id="element-58">
              <span data-id="element-59">Valor Total</span>
              <span data-id="element-60">$110</span>
            </div>
          </div>

          <div className="mb-8" data-id="element-61">
            <p className="text-matrix-muted text-sm mb-1" data-id="element-62">Tu precio hoy:</p>
            <p className="text-4xl font-black text-matrix-primary text-glow mb-1" data-id="element-63">
              $0 (GRATIS)
            </p>
            <p className="text-xs text-matrix-muted" data-id="element-64">
              cuando tomas el producto principal
            </p>
          </div>

          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full py-4 bg-matrix-primary text-matrix-bg font-bold text-lg rounded hover:bg-matrix-secondary transition-all shadow-[0_0_15px_rgba(0,255,65,0.3)] flex items-center justify-center gap-2" data-id="element-65">
            Asegura tu acceso y bonos GRATIS
            <ArrowRight className="w-5 h-5" data-id="element-66" />
          </button>
        </motion.div>
      </div>
    </section>;
}